/**
 * Swaps commas for decimals in number string
 * @param {string} numberString
 * @return {string}
 */
export function swapComma(numberString) {
  return numberString.replace(/,/g, '.');
}
